const forms = {
  form1: {
    identity: 'التعريف',
    civility: 'الحالة المدنية',
    maam: 'السيدة',
    sir: 'السيد',
    companyName: 'اسم المقاولة',
    companyNameErrorText: 'المرجو إدخال اسم مقاولتكم',
    firstName: 'الاسم العائلي',
    lastName: 'الاسم الشخصي',
    fistNameErrorText: 'المرجو إدخال اسمكم العائلي',
    lastNameErrorText: 'المرجو إدخال اسمكم الشخصي',
  },
  form2: {
    alreadyAClient: 'هل أنتم من زبنائنا  ؟',
    yes: 'نعم',
    no: 'لا',
    accountNumber: 'رقم الحساب',
    accountNumberErrorText: 'المرجو إدخال رقم حسابكم',
  },
  form3: {
    coordinates: 'العناوين',
    phoneNumber: 'رقم الهاتف',
    emailAddress: 'البريد الإلكتروني',
    city: 'المدينة',
    zipCode: 'الرمز البريدي',
    address: 'العنوان',
    addressErrorText: 'المرجو إدخال عنوانكم',
    phoneNumberErrorText: 'المرجو إدخال رقم هاتفكم',
    emailAddressErrorText: 'المرجو إدخال بريدكم الإلكتروني',
    zipCodeErrorText: 'المرجو إدخال رمزكم البريدي',
  },
  form4: {
    message: 'رسالة',
    messageErrorText: 'المرجو كتابة رسالتكم',
    objet: 'الموضوع',
  },
  form51: {
    financingDetails: 'تفاصيل التمويل',
    financingType: 'نوع التمويل',
    financingSubType: 'خيار فرعي',
    activity: 'أنشطة',
    amount: 'المبلغ',
    amountErrorText: 'المرجو إدخال مبلغ السلف',
    duration: '(المدة ( بالأشهر',
    durationErrorText: '(المرجو إدخال المدة المختارة ( بالأشهر',
    contribution: 'المبلغ المقدم',
    contributionErrorText: 'المرجو إدخال المبلغ المقدم',
  },
  form52: {
    projectDescription: 'وصف المشروع',
    descriptionErrorText: 'المرجو إدخال وصفكم',
    description: 'وصف',
  },
  common: {
    copyright:
      'COPYRIGHT 2020 - GROUPE BANQUE POPULAIRE - TOUS DROITS RÉSERVÉS',
    headerTitle: 'هوية',
    goback: 'رجوع',
    formsSubTitle: 'يرجى ملء الاستمارة أدناه',
    generalConditions1:
      '.اطلعت ووافقت على الشروط العامة للاستخدام، لاسيما المقتضيات التي تتعلق بحماية المعطيات الشخصية',
    generalConditions2:
      '.طبقا للقانون رقم 08-09، تمتلكون حق الولوج والتصحيح والتعرض على معالجة معطياتكم الشخصية',
    readGeneralConditions: 'الشروط العامة للاستخدام',
    alreadyAClient: 'هل أنتم من زبناء البنك الشعبي  ؟',
  },
};

export default forms;
